/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import { formatDate } from '../utils/dateUtils';
import { HomeCheckerShape } from '../../shapes/HomeChecker';

import HomeCheckerImage from './HomeCheckerImage';
import './VerificationInfo.scss';

export const VERIFICATION_DATE_FORMAT = 'DD MMM YYYY';

const VerificationInfo = ({
  homechecker = {},
  verificationDate = null,
  transparent = false,
  showBorder = false,
  showDescription = false,
  className = null
}) => {
  if (!homechecker || !verificationDate) {
    return null;
  }

  const { photoUrl, firstName } = homechecker;

  const containerClassNames = classNames('verification-info', className, {
    'verification-info--transparent': transparent,
    'verification-info--border': showBorder
  });

  return (
    <div className={containerClassNames}>
      <HomeCheckerImage photoUrl={photoUrl} />
      <div className="verification-info__content">
        <p
          data-test="home-checker-name"
          className="verification-info__homechecker"
        >
          {trans('HomeCheckerBox.verified.homechecker', { firstName })}
        </p>
        {verificationDate && (
          <p
            data-test="home-checker-date"
            className="verification-info__date"
            dangerouslySetInnerHTML={{
              __html: trans('HomeCheckerBox.verified.date', {
                verificationDate: formatDate(
                  verificationDate,
                  VERIFICATION_DATE_FORMAT
                )
              })
            }}
          />
        )}
        {showDescription ? (
          <div
            data-test="home-checker-info"
            className="verification-info__info"
          >
            {trans('HomeCheckerBox.verified.info')}
          </div>
        ) : null}
      </div>
    </div>
  );
};

VerificationInfo.propTypes = {
  homechecker: PropTypes.shape(HomeCheckerShape),
  verificationDate: PropTypes.string,
  transparent: PropTypes.bool,
  showBorder: PropTypes.bool,
  showDescription: PropTypes.bool,
  className: PropTypes.string
};

export default VerificationInfo;
